<ng-container [formGroup]="form">
  <ng-container [formGroupName]="inputName">
    <ion-item *ngFor="let item of list; let selectedIndex = index">
      <ion-label
        class="ion-text-wrap"
        [ngStyle]="{
          color: UtilService.getColorForAnswerChoice(item.answerChoiceAttributeColor)
        }"
        (click)="onLabelClick(item)"
      >
        {{
          UtilService.findObj(
            item.answerChoiceAttributeHeaders,
            "answerChoiceAttributeHeaderLanguageId",
            sharedDataService.getLanguageIdForForm()
          )?.answerChoiceAttributeHeaderTitle
        }}
      </ion-label>

      <ion-checkbox #inputElements mode="md" slot="start"
        [id]="'mcs-' + item.answerChoiceAttributeId"
        [attr.data-parent-answer-choice-id]="item.parentAnswerChoiceQuestionAttributeId" 

        [formControlName]="UtilService.SubFCName(inputName, item.answerChoiceAttributeId)"
        [value]="item.answerChoiceAttributeId"
        (ionChange)="updateState($event, item.answerChoiceAttributeId)"
        (touchstart)="storeTouchStart($event)"
        (touchend)="onCheckboxClick($event)"
      ></ion-checkbox>
    </ion-item>
  </ng-container>
</ng-container>
